import { CollapsibleManager } from "./components/CollapsibleManager.js";

CollapsibleManager.use();
